import { render, staticRenderFns } from "./WeightLossLayout.vue?vue&type=template&id=37ad7c10"
import script from "./WeightLossLayout.vue?vue&type=script&lang=js"
export * from "./WeightLossLayout.vue?vue&type=script&lang=js"
import style0 from "./WeightLossLayout.vue?vue&type=style&index=0&id=37ad7c10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports